module.exports = __webpack_public_path__ + "static/blog_grid_6-a09386c5b38deecd27e1d7e96cd636b3.jpg";